/* Buscador inteligente: medida en cualquier formato, marca → colección, batería + auto, sugerencias al tipear. */
(function () {
  var BRANDS = {
    yokohama: 'yokohama',
    pirelli: 'pirelli',
    bridgestone: 'bridgestone',
    continental: 'continental',
    dunlop: 'dunlop',
    firestone: 'firestone',
    nexen: 'nexen',
    linglong: 'linglong',
    fate: 'fate',
    kumho: 'kumho',
    michelin: 'michelin',
    goodyear: 'goodyear',
    hankook: 'hankook',
    sunny: 'sunny',
    wanli: 'wanli',
    xbri: 'xbri',
    triangle: 'triangle',
    firemax: 'firemax',
    lanvigator: 'lanvigator',
    westlake: 'west-lake',
    'west lake': 'west-lake',
    'west-lake': 'west-lake',
    windforce: 'windforce',
    maxtrek: 'maxtrek',
    doublestar: 'doublestar',
    falken: 'falken',
    speedmax: 'speedmax',
    tronmax: 'tronmax'
  };
  var BAT = ['fiat','ford','chevrolet','volkswagen','vw','peugeot','citroen','toyota','honda','renault','nissan','jeep','chery','bmw','audi','mercedes','dodge','kia','hyundai','ranger','amarok','hilux','focus','gol','corsa','cronos','onix','clio','sandero','duster','kangoo','corolla','etios','ecosport','ka','fiesta','polo','vento','saveiro','tucson','ram'];
  var NOISE = /^(cubiertas?|gomas?|neum[aá]ticos?|cubierta|goma|precio|baratas?|oferta|ofertas|para|de|el|la|las|los|una|un|en|con|medida|rodado)$/i;

  function fold(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }
  function parseSize(q) {
    var s = String(q || '').replace(/,/g, '.');
    var m = s.match(/(\d{2,3})\s*[/\-]\s*(\d{2})\s*[/\-]?\s*(?:[zZ]?[rR]\s*)?(\d{2})\b/);
    if (m) return m[1] + '/' + m[2] + ' R' + m[3];
    m = s.match(/(\d{2,3})\s+(\d{2})\s+(?:[zZ]?[rR]\s*)?(\d{2})\b/);
    if (m) return m[1] + '/' + m[2] + ' R' + m[3];
    return '';
  }
  function parseBrand(q) {
    var f = fold(q);
    var keys = Object.keys(BRANDS).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (new RegExp('\\b' + k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b').test(f)) return BRANDS[k];
    }
    return '';
  }
  function detectBatVehicle(q) {
    var f = fold(q);
    if (!/bateria/.test(f)) return '';
    for (var i = 0; i < BAT.length; i++) {
      if (new RegExp('\\b' + BAT[i].replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b').test(f)) return BAT[i];
    }
    return '';
  }
  function rewrite(raw) {
    var q = String(raw || '').replace(/\s+/g, ' ').trim();
    if (!q) return '';
    var size = parseSize(q);
    var brand = parseBrand(q);
    var parts = [];
    if (size) parts.push(size);
    if (brand) parts.push(brand.charAt(0).toUpperCase() + brand.slice(1));
    if (parts.length) return parts.join(' ');
    return q.split(/\s+/).filter(function (w) { return w && !NOISE.test(w); }).join(' ') || q;
  }
  function brandOnly(q) {
    var f = fold(q).split(/\s+/).filter(function (w) { return w && !NOISE.test(w); });
    if (f.length === 1 && BRANDS[f[0]]) return '/collections/' + BRANDS[f[0]];
    if (f.length === 2 && BRANDS[f[0] + ' ' + f[1]]) return '/collections/' + BRANDS[f[0] + ' ' + f[1]];
    return '';
  }
  function money(n) {
    var x = Math.round(Number(n) || 0);
    return '$' + x.toLocaleString('es-AR');
  }
  function sizeSlug(size) {
    var m = String(size || '').match(/(\d+)\/(\d+)\s*R(\d+)/i);
    return m ? (m[1] + '-' + m[2] + '-r' + m[3]) : '';
  }
  function destFor(raw) {
    var q = String(raw || '').trim();
    var v = detectBatVehicle(q);
    if (v) return { kind: 'bat', tag: v };
    var size = parseSize(q);
    var brand = parseBrand(q);
    var slug = sizeSlug(size);
    if (brand && slug) {
      return { kind: 'col', url: '/collections/' + brand + '-' + slug, fallback: '/collections/neumaticos-' + slug };
    }
    if (slug) return { kind: 'col', url: '/collections/neumaticos-' + slug };
    var col = brandOnly(q);
    if (col) return { kind: 'url', url: col };
    var nq = rewrite(q);
    return { kind: 'search', q: nq || q };
  }
  function go(raw) {
    var d = destFor(raw);
    if (d.kind === 'url') { location.href = d.url; return; }
    if (d.kind === 'col') {
      fetch(d.url + '.json')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (data && data.collection) location.href = d.url;
          else if (d.fallback) location.href = d.fallback;
          else location.href = '/search?type=product&q=' + encodeURIComponent(rewrite(raw) || raw);
        })
        .catch(function () { location.href = d.fallback || ('/search?type=product&q=' + encodeURIComponent(raw)); });
      return;
    }
    if (d.kind === 'bat') {
      var tag = encodeURIComponent(d.tag.replace(/\s+/g, '-'));
      fetch('/collections/baterias/' + tag + '.json')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.products && data.products.length) location.href = '/collections/baterias/' + tag;
          else location.href = '/search?type=product&q=' + encodeURIComponent(rewrite(raw) || raw);
        })
        .catch(function () { location.href = '/search?type=product&q=' + encodeURIComponent(raw); });
      return;
    }
    location.href = '/search?type=product&q=' + encodeURIComponent(d.q);
  }

  var box = null;
  var timer = 0;
  var lastInput = null;
  function ensureBox() {
    if (box) return box;
    box = document.createElement('div');
    box.className = 'nf-sg';
    box.hidden = true;
    document.body.appendChild(box);
    box.addEventListener('mousedown', function (e) { e.preventDefault(); });
    return box;
  }
  function hideBox() { if (box) box.hidden = true; }
  function placeBox(input) {
    var r = input.getBoundingClientRect();
    var b = ensureBox();
    var w = Math.min(Math.max(r.width, 280), window.innerWidth - 16);
    b.style.position = 'fixed';
    b.style.left = Math.max(8, Math.min(r.left, window.innerWidth - w - 8)) + 'px';
    b.style.top = Math.min(r.bottom + 6, window.innerHeight - 80) + 'px';
    b.style.width = w + 'px';
  }
  function render(input, products, q) {
    var b = ensureBox();
    placeBox(input);
    b.innerHTML = '';
    if (!products.length) { b.hidden = true; return; }
    products.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'nf-sg__it';
      a.href = p.url || ('/products/' + p.handle);
      var img = document.createElement('img');
      img.alt = '';
      img.loading = 'lazy';
      var src = p.image || (p.featured_image && p.featured_image.url) || '';
      img.src = src ? (src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=96') : '';
      if (!src) img.style.visibility = 'hidden';
      var tx = document.createElement('span');
      tx.className = 'nf-sg__tx';
      var t = document.createElement('b');
      t.textContent = p.title || '';
      var s = document.createElement('small');
      s.textContent = (p.vendor ? p.vendor + ' · ' : '') + money(p.price);
      tx.appendChild(t);
      tx.appendChild(s);
      a.appendChild(img);
      a.appendChild(tx);
      b.appendChild(a);
    });
    var more = document.createElement('a');
    more.className = 'nf-sg__more';
    var dest = destFor(input.value);
    if (dest.kind === 'col' || dest.kind === 'url') {
      more.href = dest.url;
      more.textContent = dest.kind === 'col' ? 'Ver stock de esta medida' : 'Ver la marca';
    } else {
      more.href = '/search?type=product&q=' + encodeURIComponent(q);
      more.textContent = 'Ver todos los resultados';
    }
    b.appendChild(more);
    b.hidden = false;
  }
  function suggest(input) {
    var raw = input.value.trim();
    if (raw.length < 2) { hideBox(); return; }
    var q = rewrite(raw) || raw;
    lastInput = input;
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (input !== lastInput) return;
        var list = (((data || {}).resources || {}).results || {}).products || [];
        render(input, list, q);
      })
      .catch(function () { hideBox(); });
  }
  function bindInput(input) {
    if (!input || input.dataset.nfSmart) return;
    input.dataset.nfSmart = '1';
    input.setAttribute('autocomplete', 'off');
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { suggest(input); }, 160);
    });
    input.addEventListener('keyup', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { suggest(input); }, 160);
    });
    input.addEventListener('blur', function () { setTimeout(hideBox, 180); });
  }
  function bindForm(form) {
    if (!form || form.dataset.nfSmartForm) return;
    form.dataset.nfSmartForm = '1';
    form.addEventListener('submit', function (e) {
      var input = form.querySelector('input[type="search"], input[name="q"]');
      if (!input) return;
      e.preventDefault();
      hideBox();
      go(input.value);
    });
  }
  function scan() {
    document.querySelectorAll('form[action*="/search"], form[role="search"], form.nf-search, form.nf-srch__form, form.nfm-search, form.nfm-sz').forEach(bindForm);
    document.querySelectorAll('input[type="search"], input[name="q"]').forEach(bindInput);
  }
  function emptyRescue() {
    if (location.pathname.indexOf('/search') !== 0) return;
    if (!document.querySelector('.nfm-empty')) return;
    var params = new URLSearchParams(location.search);
    if (params.get('nfsmart')) return;
    var q = params.get('q') || '';
    var nq = rewrite(q);
    if (nq && fold(nq) !== fold(q)) {
      params.set('q', nq);
      params.set('type', 'product');
      params.set('nfsmart', '1');
      location.replace('/search?' + params.toString());
    }
  }
  window.addEventListener('resize', function () {
    if (box && !box.hidden && lastInput) placeBox(lastInput);
  }, { passive: true });
  if (document.readyState !== 'loading') { scan(); emptyRescue(); }
  else document.addEventListener('DOMContentLoaded', function () { scan(); emptyRescue(); });
  setInterval(scan, 2000);
})();
